import type { CodeWorldSlug as LessonCodeWorldSlug } from '@vrlearning/lesson-schema';
import { TAKEN_OVER } from './taken-over.js';
import type { WorldDefinition } from './world.js';

/** The slugs this headset still builds in code: the schema's, less the ones a package took over. */
export type CodeWorldSlug = Exclude<LessonCodeWorldSlug, (typeof TAKEN_OVER)[number]>;

/**
 * Every code world the headset can build, by slug. A slug a package took over (taken-over.ts) has
 * no entry: the package serves it. Since 12 Oct 2026 every world is a package (ADR-050), so there
 * are none; the villa's code (villa.ts) stays only for the console's furniture viewer.
 */
export const WORLD_DEFINITIONS: Readonly<Record<CodeWorldSlug, WorldDefinition>> = {};

export function registeredWorlds(): CodeWorldSlug[] {
  return Object.keys(WORLD_DEFINITIONS) as CodeWorldSlug[];
}
